module.exports = __webpack_public_path__ + "img/carupdate.2eb74f72.webp";